import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";
import {
  FormattedMessage,
  IntlProvider,
} from "react-intl";
import ReactPhoneInput from "react-phone-input-2";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  LogMeOut,
  updateAuthentication,
} from "../../../Actions/AuthenticationAction";
import { instance } from "../../../Actions/AxiosInstance";
import { updateSubscriptionInfo } from "../../../Actions/SubscriptionInfo";
import {
  ValidateAction,
  ValidateReqField,
  ValidateReqFields,
} from "../../../Utils/Validation";
import employee from "../../../Assets/Images/employee.svg";
import createstore from "../../../store";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import { ReducersTypes } from "../../../Constants";
import "./Profile.css";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
});
const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px dashed rgb(102, 102, 102)",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
  borderWidth: 2,
};

class ProfileLandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      subdomain: window.location.hostname,
      candidateemailid: null,
      candidatemobilenumber: null,
      callingcode: null,
      flag: 1,
      reqFields: {
        companyotp: "",
        OTP: "",
        mobilenumber: "",
        emailid: "",
      },
      fields: {
        companyotp: "",
        OTP: "",
        mobilenumber: "",
        callingcode: "",
        emailid: "",
      },
      errors: {},
      helperText: {},
      selectedValue: 1,
      dropdown: [
        { displayvalue: 1, displayname: "Mobile Number" },
        { displayvalue: 2, displayname: "Email" },
      ],
    };
    
    this.VerifyCompanyOTP = this.VerifyCompanyOTP.bind(this);
  }

  // componentDidMount() {
  //     CustomForm();
  // }

  componentWillMount() {
    this.props.ChangeLanguage("profilelandingpage");
    if (get(this.props, "AuthenticationAction.login.userid", "")) {
      // this.props.LogMeOut(get(this.props, "AuthenticationAction.login.userid", ""));
    }
    // let subdomain = this.state.subdomain.split('.')
    // subdomain = subdomain[0]
    // if (this.state.subdomain != "accounts" || this.state.subdomain != "superuser") {
    //     this.props.VerifySubscription(subdomain)
    // }
    // let SubscriptionInfo = createstore.getState().SubscriptionInfo;
    // let subscriptionid = SubscriptionInfo.SubscriptionData.subscriptionid;
    // let accountid = SubscriptionInfo.SubscriptionData.accountid;
    // this.setState({ subscriptionid, accountid })
  }

  componentDidMount() {
    // let subdomain = this.state.subdomain.split('.')
    // subdomain = subdomain[0]
    // this.props.VerifySubscription(subdomain)
  }

  componentWillReceiveProps(props) {
    console.log("1SubscriptionInfo: ", props);

    if (props.SubscriptionInfo.IsError) {
      this.props.enqueueSnackbar(props.SubscriptionInfo.ErrorMessage, {
        variant: "error",
      });
      this.props.history.push("/**");
      // this.props.updateAuthentication('LOGIN_PENDING', null)
    } else if (props.SubscriptionInfo.IsFulfilled) {
      const SubscriptionDetails = props.SubscriptionInfo.SubscriptionData;
      const { subscriptionid } = SubscriptionDetails;
      const { accountid } = SubscriptionDetails;
      this.setState({ SubscriptionDetails, subscriptionid, accountid });
    }
  }

  SetFlag(value, e) {
    const flag = value;
    this.setState({ flag });
  }

  GetDropdownValue(e) {
    this.setState({ selectedValue: e.target.value ? e.target.value : "" });
  }

  SetHelperTextFlag(field, HtField, e) {
    const { helperText } = this.state;
    helperText[field] = true;
    this.setState({ helperText });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields });
    ValidateAction(this.state, field, type);

    if (type == "numbers-only") {
      this.state.fields[field] = e.target.value.replace(/[^0-9]/g, "");
    }
  }

  OnPhoneChange(field, value) {
    this.state.fields.countryname = value.name;
    this.state.fields.callingcode = value.dialCode;
    this.state.fields.mobilenumber = field;
    field = field.replace(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, "");
    const no = field.replace(value.dialCode, "");
    this.state.fields.no = no.trim();

    const { fields } = this.state;
    this.setState({ fields });
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  VerifyCompanyOTP() {
    const URL = `employee/verifysubscriptionotp`;
    const data = {
      subscriptionid: get(
        this.props,
        "SubscriptionInfo.SubscriptionData.subscriptionid",
        "",
      ),
      accountid: get(
        this.props,
        "SubscriptionInfo.SubscriptionData.accountid",
        "",
      ),
      subscriptionotp: this.state.fields.companyotp,
    };

    instance
      .post(URL, data)
      .then((result) => {
        this.props.enqueueSnackbar("successfully", { variant: "success" });
        const { companyotp } = this.state.fields;
        const candidateemailid = result.data.result[0].candidateemailid;
        const candidateid = result.data.result[0].candidateid;
        const candidatemobilenumber =
          result.data.result[0].candidatemobilenumber;
        const callingcode = result.data.result[0].callingcode;
        const info = createstore.getState().SubscriptionInfo.SubscriptionData;
        result.data.result[0] = Object.assign(info, {
          companyotp,
          candidateemailid,
          candidatemobilenumber,
          candidateid,
          callingcode,
        });
        this.props.updateSubscriptionInfo(
          `${ReducersTypes.SUBSCRIPTIONINFO}_FULFILLED`,
          result,
        );

        this.props.history.push("/newemployee/basic");
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  SendMobileOTP() {
    const number = this.state.fields.callingcode + this.state.fields.no;
    const URL = `employee/verifyempprimarymobile`;
    const data = {
      subscriptionid: this.state.subscriptionid,
      accountid: this.state.accountid,
      callingcode: this.state.fields.callingcode,
      primarymobile: this.state.fields.no,
      mobilenumber: number,
      isprospect: true,
    };

    instance
      .post(URL, data)
      .then((result) => {
        this.props.enqueueSnackbar("OTP Sent successfully On Your Mobile", {
          variant: "success",
        });
        const info = result.data.result[0];
        this.setState({
          employeeid: info.employeeid,
          flag: 4,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  SendEmailOTP() {
    const URL = `employee/generateemailotp`;
    const data = {
      subscriptionid: this.state.subscriptionid,
      accountid: this.state.accountid,
      callingcode: this.state.fields.callingcode,
      senton: this.state.fields.emailid,
      isonmail: true,
      otptypeid: 1,
      timezoneid: null,
      userid: null,
      // callingcode: null,
      employeeid: null,
    };

    instance
      .post(URL, data)
      .then((result) => {
        this.props.enqueueSnackbar("OTP Sent successfully On Your Email-Id", {
          variant: "success",
        });
        const info = result.data.result[0];
        this.setState({
          employeeid: info.employeeid,
          flag: 4,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  VerifyOTP() {
    let URL;
    if (this.state.selectedValue == 1) {
      const number = this.state.fields.callingcode + this.state.fields.no;
      // URL = `sms/verifyotp/${number}/${this.state.fields.OTP}`;
      URL = "sms/verifyotp";
      const data = {
        otp: this.state.fields.OTP,
        mobilenumber: number,
        accountid: this.props.SubscriptionInfo.SubscriptionData.accountid,
        subscriptionid:
          this.props.SubscriptionInfo.SubscriptionData.subscriptionid,
        employeeid: this.state.employeeid,
        timezoneid:
          this.props.SubscriptionInfo.SubscriptionData.countrytimezoneid,
        dateformat: this.props.SubscriptionInfo.SubscriptionData.dateformatname,
      };

      instance
        .post(URL, data)
        .then((result) => {
          const employeeid = get(result, "data.result[0].employeeid", "");
          const token = get(result, "data.result[0].token", "");
          let subscriptioninfo =
            createstore.getState().SubscriptionInfo.SubscriptionData;
          subscriptioninfo = { ...subscriptioninfo, employeeid, token };
          console.log("subscriptioninfo: ", subscriptioninfo);
          this.props.updateSubscriptionInfo(
            `${ReducersTypes.SUBSCRIPTIONINFO}_UPDATED_FOR_EMPLOYEEID`,
            subscriptioninfo,
          );
          this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
            IsFulfilled: false,
            data: null,
          });
          setTimeout(() => {
            const URL = `${window.location.origin}/newemployee/completeprofile`;
            console.log("URL: ", URL);
            // this.props.history.push("/newemployee/completeprofile");
            window.open(URL, "_self");
          }, 500);
          // this.props.history.push("/newemployee/completeprofile");
          // var imgObj = imgresult.data.result[0]["imagesArray"].find(x => x.imagetype == 4);
          // this.setState({ ProfileImg: imgObj.imagepath });
          // let resultApi = result.data.result[0];
          // let info = createstore.getState().SubscriptionInfo.SubscriptionData;
          // result.data.result[0] = Object.assign(resultApi, info, { employeeid });
          // this.props.enqueueSnackbar("Saved successfully", { variant: "success" });
          // this.props.updateSubscriptionInfo(ReducersTypes.SUBSCRIPTIONINFO + "_FULFILLED", result);
          // this.props.history.push(`/newemployee/completeprofile`);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else if (this.state.selectedValue == 2) {
      // URL = `sms/verifyotp/${this.state.fields.emailid}/${this.state.fields.OTP}`;
      URL = `employee/verifygeneratedotp`;

      const data = {
        accountid: this.props.SubscriptionInfo.SubscriptionData.accountid,
        subscriptionid:
          this.props.SubscriptionInfo.SubscriptionData.subscriptionid,
        senton: this.state.fields.emailid,
        otp: this.state.fields.OTP,
        timezoneid:
          this.props.SubscriptionInfo.SubscriptionData.countrytimezoneid,
        dateformatname:
          this.props.SubscriptionInfo.SubscriptionData.dateformatname,
      };

      instance
        .post(URL, data)
        .then((result) => {
          const employeeid = get(result, "data.result[0].employeeid", "");
          const token = get(result, "data.result[0].token", "");
          let subscriptioninfo =
            createstore.getState().SubscriptionInfo.SubscriptionData;
          subscriptioninfo = { ...subscriptioninfo, employeeid, token };
          console.log("subscriptioninfo: ", subscriptioninfo);
          this.props.updateSubscriptionInfo(
            `${ReducersTypes.SUBSCRIPTIONINFO}_UPDATED_FOR_EMPLOYEEID`,
            subscriptioninfo,
          );
          this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
            IsFulfilled: false,
            data: null,
          });
          setTimeout(() => {
            const URL = `${window.location.origin}/newemployee/completeprofile`;
            console.log("URL: ", URL);
            // this.props.history.push("/newemployee/completeprofile");
            window.open(URL, "_self");
          }, 500);
          // let employeeid = result.data.result[0].employeeid;
          // let info = createstore.getState().SubscriptionInfo.SubscriptionData;
          // result.data.result[0] = Object.assign(info, { employeeid });
          // this.props.updateSubscriptionInfo(ReducersTypes.SUBSCRIPTIONINFO + "_FULFILLED", result);
          // setTimeout(() => {
          //   let URL = `${window.location.origin}/newemployee/completeprofile`;
          //   window.open(URL, "_self");
          // }, 500);
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  render() {
    const { classes, theme } = this.props;
    const { value } = this.state;
    const language = this.props.Language.profilelandingpage;
    const { flag } = this.state;
    let model;
    if (flag === 1) {
      model = (
        <div>
          <div className="login-into-your-sumhr">
            <FormattedMessage
              id="LbWhatdoyouwanttodo"
              defaultMessage="What do you want to do today?"
            />
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              className="confirm-transfer-btn width100"
              onClick={this.SetFlag.bind(this, 2)}
            >
              <FormattedMessage
                id="BtAddmyselfasemployee"
                defaultMessage="ADD MYSELF AS EMPLOYEE"
              />
            </Button>
          </div>
          <div className="profile-data text-center">
            <FormattedMessage id="LbOr" defaultMessage="Or" />
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              className="confirm-transfer-btn width100"
              onClick={this.SetFlag.bind(this, 3)}
            >
              <FormattedMessage
                id="BtEditmyexistingprofile"
                defaultMessage="EDIT MY EXISTING PROFILE"
              />
            </Button>
          </div>
        </div>
      );
    } else if (flag === 2) {
      model = (
        <div className="profile-form">
          <div className="login-into-your-sumhr">
            <FormattedMessage
              id="LbAddMyselfAsEmployee"
              defaultMessage="Get started"
            />
          </div>
          <div>
            <div className="profile-data">
              {/* <input
                            type="text"
                            class="form-control"
                            id="companyotp"
                            placeholder="Company OTP"
                            onFocus={this.SetHelperTextFlag.bind(this, "companyotp", "HtCompanyotp")}
                            onChange={this.OnFieldChange.bind(this, "companyotp", "text")}
                            onBlur={this.ValidateField.bind(this, "companyotp", "text")}
                            value={this.state.fields.companyotp}
                            maxLength="4"
                            className="profile-input"
                            /> */}
              <p className="form-input-label">Company code</p>
              <TextField
                id="outlined-with-placeholder"
                // label="Company code"
                className="profile-input"
                style={{ padding: 0 }}
                margin="dense"
                variant="outlined"
                // placeholder="Company code"
                onFocus={this.SetHelperTextFlag.bind(
                  this,
                  "companyotp",
                  "HtCompanyotp",
                )}
                onChange={this.OnFieldChange.bind(this, "companyotp", "")}
                onBlur={this.ValidateField.bind(this, "companyotp", "")}
                value={this.state.fields.companyotp}
                inputProps={{ maxLength: 5 }}
              />
            </div>
            <div>
              {this.state.errors.companyotp ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErCompanyotp"
                    defaultMessage="company otp can not be empty"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="padding-top-15">
            <div>
              <Button
                variant="contained"
                color="primary"
                className="confirm-transfer-btn"
                onClick={this.VerifyCompanyOTP.bind(this)}
              >
                <FormattedMessage
                  id="BtGetstarted"
                  defaultMessage="get started"
                />
              </Button>
              <Button
                variant="outlined"
                // variant="contained"
                color="primary"
                className="confirm-transfer-btn margin-top-20"
                onClick={this.SetFlag.bind(this, 1)}
              >
                <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
              </Button>
            </div>
          </div>
        </div>
      );
    } else if (flag === 3) {
      model = (
        <div className="profile-form">
          <div className="login-into-your-sumhr">
            <FormattedMessage
              id="LbEditMyExistingProfile"
              defaultMessage="Edit my existing profile"
            />
          </div>
          <div>
            <div>
              <Select
                style={{ width: 340 }}
                className="margin-top-20 margin-bottom-20"
                value={this.state.selectedValue}
                onChange={this.GetDropdownValue.bind(this)}
              >
                {this.state.dropdown.map((row, id) => (
                  <MenuItem value={row.displayvalue} name={row.displayname}>
                    {row.displayname}
                  </MenuItem>
                ))}
              </Select>
              <div className="profile-form">
                {this.state.selectedValue == 1 ? (
                  <div>
                    <div className="padding-bottom-30">
                      <div className="emp-from-landing">
                        <ReactPhoneInput
                          defaultCountry={"in"}
                          countryCodeEditable={false}
                          onFocus={this.SetHelperTextFlag.bind(this, "no")}
                          onChange={this.OnPhoneChange.bind(this)}
                          onBlur={this.ValidateField.bind(this, "no", "mobile")}
                          value={this.state.fields.mobilenumber}
                          error={!!this.state.errors.no}
                          InputProps={{ maxLength: 15, minLength: 5 }}
                        />
                      </div>
                      <div>
                        {this.state.errors.no ? (
                          <span className="caption-error">
                            <FormattedMessage
                              id="ErMobileNo"
                              defaultMessage="We won't call you past midnight 😅"
                            />
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <Button
                      variant="contained"
                      color="primary"
                      className="confirm-transfer-btn"
                      onClick={this.SendMobileOTP.bind(this)}
                    >
                      <FormattedMessage
                        id="BtGetstarted"
                        defaultMessage="get started"
                      />
                    </Button>

                    <Button
                      variant="outlined"
                      // variant="contained"
                      color="primary"
                      className="confirm-transfer-btn margin-top-20"
                      onClick={this.SetFlag.bind(this, 1)}
                    >
                      <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                    </Button>
                  </div>
                ) : (
                  <div>
                    <div className="emp-from-landing">
                      <input
                        type="text"
                        className="form-control emp-from-email"
                        id="emailid"
                        placeholder="Email Id"
                        onFocus={this.SetHelperTextFlag.bind(
                          this,
                          "emailid",
                          "HtEmailid",
                        )}
                        onChange={this.OnFieldChange.bind(
                          this,
                          "emailid",
                          "text",
                        )}
                        onBlur={this.ValidateField.bind(
                          this,
                          "emailid",
                          "text",
                        )}
                        value={this.state.fields.emailid}
                        maxLength="100"
                        style={{ border: "1px solid #cacaca", width: 340 }}
                      />
                    </div>
                    <div>
                      {this.state.errors.emailid ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErEmailid"
                            defaultMessage="Are you sure you've entered a correct email? Please re check 🙏"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <Button
                      variant="contained"
                      color="primary"
                      className="confirm-transfer-btn"
                      onClick={this.SendEmailOTP.bind(this)}
                    >
                      <FormattedMessage
                        id="BtGetstarted"
                        defaultMessage="get started"
                      />
                    </Button>

                    <Button
                      variant="outlined"
                      // variant="contained"
                      color="primary"
                      className="confirm-transfer-btn margin-top-20"
                      onClick={this.SetFlag.bind(this, 1)}
                    >
                      <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div />
        </div>
      );
    } else if (flag === 4) {
      model = (
        <div className="profile-form">
          <div className="login-into-your-sumhr">
            {this.state.selectedValue == 1 ? (
              <FormattedMessage
                id="LbCheckyourmobileforOTP"
                defaultMessage="Check your mobile for OTP"
              />
            ) : (
              <FormattedMessage
                id="LbCheckyouremailforOTP"
                defaultMessage="Check your email for OTP"
              />
            )}
          </div>
          <div>
            <div className="emp-from-landing">
              {/* <input type="text" class="form-control" id="OTP" placeholder="OTP"
                                onFocus={this.SetHelperTextFlag.bind(this, "OTP", "HtOTP")}
                                onChange={this.OnFieldChange.bind(this, "OTP", "text")}
                                onBlur={this.ValidateField.bind(this, "OTP", "text")}
                                value={this.state.fields.OTP}
                                maxLength="4"
                                className="emp-landing-input" /> */}

              <TextField
                id="outlined-with-placeholder"
                label="OTP"
                placeholder="OTP"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                onFocus={this.SetHelperTextFlag.bind(this, "OTP", "HtOTP")}
                onChange={this.OnFieldChange.bind(this, "OTP", "numbers-only")}
                onBlur={this.ValidateField.bind(this, "OTP", "numbers-only")}
                value={this.state.fields.OTP}
                maxLength="4"
              />
            </div>
            <div>
              {this.state.errors.OTP ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErOTP"
                    defaultMessage="otp can not be empty"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="padding-top-15">
            <Button
              variant="contained"
              color="primary"
              className="confirm-transfer-btn margin-top-20"
              onClick={this.VerifyOTP.bind(this)}
            >
              <FormattedMessage
                id="BtGetstarted"
                defaultMessage="get started"
              />
            </Button>

            <Button
              variant="outlined"
              // variant="contained"
              color="primary"
              className="confirm-transfer-btn margin-top-20"
              onClick={this.SetFlag.bind(this, 1)}
            >
              <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
            </Button>
          </div>
        </div>
      );
    }
    return (
      <IntlProvider locale="en" messages={language}>
        <div className={classes.root}>
          <Grid container className="win-height padding-top-90">
            <Grid item xs={12} md={6} sm={12}>
              <div>
                <div className="width400 align-center">
                  {/* <div align="center">
                                        <img src={BankImg} height="90" />
                                    </div> */}
                  <div className="hello-welcome">
                    <FormattedMessage
                      id="HdHellowelcome!"
                      defaultMessage="Hello, welcome!"
                    />
                  </div>
                  {model}
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6} sm={12}>
              <div>
                <div align="center">
                  <img className="profile-landing-emp-img" src={employee} />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </IntlProvider>
    );
  }
}

ProfileLandingPage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateAuthentication,
      LogMeOut,
      ChangeLanguage: (data) => ChangeLanguage(data),
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ProfileLandingPage)));
